import React from 'react'
import { Link } from "react-router-dom";
export default function TopbarAgencyUser() {
  return (
    <>
      <div className="d-flex flex-row-reverse">
        <div className="">
          {sessionStorage.getItem('userNameUser')}
          &nbsp; &nbsp;
          <Link to="/agency-change-password">
            <i className='bx bx-cog icon'></i>

          </Link>

        </div>
      </div>
    </>
  )
}
